import { CrowdctrlListComponent } from '../list/list.component';
import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonToggle, IonButton, IonIcon, IonPopover, IonItem, IonLabel, IonSpinner } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { createOutline, ellipsisVertical } from 'ionicons/icons';

addIcons({ ellipsisVertical, createOutline });

@Component({
  selector: 'crowdctrl-toggle-item',
  standalone: true,
  imports: [
    CommonModule,
    IonToggle,
    IonButton,
    IonIcon,
    IonPopover,
    CrowdctrlListComponent,
    IonItem,
    IonLabel,
    IonSpinner,
  ],
  templateUrl: './toggle-item.component.html',
  styleUrl: './toggle-item.component.css',
})
export class ToggleItemComponent {
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() toggleId: string = '';
  @Input() menuId: string = '';
  @Input() showMenu: boolean = true;
  @Input() extraMenuItems: { id: string; label: string; icon?: string }[] = [];
  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() menuEdit = new EventEmitter<void>();
  @Output() menuExtraAction = new EventEmitter<string>();

  onToggleChange(event: CustomEvent): void {
    if (this.disabled) {
      event.preventDefault();
      return;
    }
    const checked = event.detail.checked;
    this.toggleChange.emit(checked);
  }

  onEditClick(): void {
    this.menuEdit.emit();
  }

  onExtraActionClick(itemId: string): void {
    this.menuExtraAction.emit(itemId);
  }
}
